import {
    useMixedGroupedFilteredStoreCreator,
    UseMixedGroupedStore,
} from '../mixed-grouped.store';
import { UseSimpleStore } from '@om-fe/store';
import { MixedGroupedTournamentModel } from '../mixed-grouped.types';

export function useMixedGroupedOddsStoreCreator(
    mixedStore: UseMixedGroupedStore,
): UseSimpleStore<MixedGroupedTournamentModel> {
    return useMixedGroupedFilteredStoreCreator(mixedStore, 'oddsList');
}
